// Visual parity with legacy 404 (dark bg, centered Next-style message).
// Matched by path: '*' in routes.partial.ts so any unrecognized URL lands here.

/**
 * Catch-all 404 page. Renders the legacy/Next-style not-found screen.
 * Works inside or outside the DashboardLayout because it carries its own shell.
 */
export default function NotFoundPage(): React.JSX.Element {
  return (
    <div
      data-testid="not-found-page"
      className="flex min-h-dvh items-center justify-center bg-background px-6 text-center text-foreground"
    >
      <div className="flex items-center">
        <h1 className="mr-5 border-r border-border pr-6 text-2xl font-medium leading-[49px]">
          404
        </h1>
        <h2 className="text-sm font-normal leading-[49px]">
          This page could not be found.
        </h2>
      </div>
    </div>
  );
}
